// src/components/SearchBar.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';

// Container for the entire SearchBar
const SearchBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 1rem;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
`;

// Input field wrapper for search bar, with no background for the overall card
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #66bb6a;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  background-color: white; /* Only the search input field has a white background */
  width: 100%;
  max-width: 370px;
//   box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
//   margin-top: 10px;
  position: absolute;
  top:10%;
  left: 50%;
  transform: translateX(-50%);
`;

// Input field style for search bar
const Input = styled.input`
  border: none;
  outline: none;
  width: 100%;
  padding: 0.5rem;
  font-size: 1.1rem;
  color: #66bb6a;
  margin-left: 0.5rem;
`;

// Carousel Styling
const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
//   height: 300px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

const CarouselImages = styled.div`
  display: flex;
  transition: transform 0.5s ease;
`;

const CarouselImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px; // Rounded corners for images
  @media (max-width: 768px) {
    height: 250px; // Adjust height on smaller screens
  }
`;

const SearchFieldContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  background: white;
  border-radius: 15px;
  padding: 12px 20px;
  width: 80%;
  max-width: 500px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
`;

const SearchFieldLabel = styled.label`
  font-size: 1rem;
  color: black;
  display: block;
  margin-bottom: 8px;
`;

const SearchFieldInput = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 1.2rem;
  color: #66bb6a;
  background: transparent;
  border: 1px solid #66bb6a;
  border-radius: 25px;
  outline: none;
  font-weight: 500;
`;

const SliderIndicator = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 5px;
`;

const SliderDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ isActive }) => (isActive ? '#388e3c' : '#66bb6a')};
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const SearchBar = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselImages = [
    '/images/court.png', // Replace with actual images
    '/images/court1.png', // Replace with actual images
    
  ];

  // Carousel auto transition
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    }, 5000); // Transition every 5 seconds

    return () => clearInterval(interval); // Clean up the interval on unmount
  }, []);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      {/* Carousel */}
      <CarouselContainer>
        <CarouselImages style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {carouselImages.map((image, index) => (
            <CarouselImage key={index} src={image} alt={`Carousel Image ${index + 1}`} />
          ))}
        </CarouselImages>

       

        {/* Slider Indicator (Dots) */}
        <SliderIndicator>
          {carouselImages.map((_, index) => (
            <SliderDot
              key={index}
              isActive={currentIndex === index}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </SliderIndicator>
      </CarouselContainer>
    </>
  );
};

export default SearchBar;
